import React from 'react'
import Modal from 'components/Luxkit/Modal/Modal'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import BodyText from 'components/Luxkit/Typography/BodyText'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'
import Heading from 'components/Luxkit/Typography/Heading'
import useLoyaltyUserBenefit from 'loyalty/hooks/useLoyaltyUserBenefit'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import LoyaltyPointsListItem from './LoyaltyPointsListItem'
import Group from 'components/utils/Group'

const BenefitDetailsContainer = styled.div`
  border: 1px solid ${props => props.theme.palette.neutral.default.seven};
`

const UpgradeTitle = styled(BodyTextBlock)`
  padding: ${rem(12)} ${rem(20)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.seven};
`

const UpgradesAvailableContainer = styled(Group)`
  padding: ${rem(12)} ${rem(20)};
`

const ExpiryDetail = styled(BodyText)`
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

function LoyaltyRoomUpgradeBenefitModal() {
  const displayTier = useAppSelector(getLoyaltyDisplayTier)
  const loyaltyUpgradeBenefit = useLoyaltyUserBenefit('hotel_upgrade')
  const statusReviewDate = useAppSelector(state => state.loyalty.account.data?.statusReviewDate)

  return <Modal title={`${getLoyaltyProgramDisplayName()} free room upgrades`}>
    <VerticalSpacer gap={24}>
      <BodyText variant="large">
        As a {getLoyaltyProgramDisplayName()} {getLoyaltyTierDisplayName(displayTier)} member you have free room{' '}
        upgrades available on select hotel offers to use in your membership year.
      </BodyText>
      <BenefitDetailsContainer>
        <UpgradeTitle variant="medium" weight="bold" startIcon={<LineRoomUpgradeIcon size="M" />} colour="neutral-two">
          Free room upgrades
        </UpgradeTitle>
        <UpgradesAvailableContainer direction="horizontal" horizontalAlign="space-between">
          <LoyaltyPointsListItem tier={displayTier} size="M" colour="neutral-two">
            Available upgrades
          </LoyaltyPointsListItem>
          <Heading variant="heading6" colour="neutral-two">
            {loyaltyUpgradeBenefit?.unlimited ? 'unlimited' : `x${loyaltyUpgradeBenefit?.remaining}`}
          </Heading>
        </UpgradesAvailableContainer>
        {/* Lowest ranked tier that has room upgrades */}
        {displayTier === 'gold' && !!statusReviewDate && <ExpiryDetail variant="small" colour="neutral-two">
          Benefit expires <b><FormatDateTime value={statusReviewDate} format="day-long-month-long-year" /></b>
        </ExpiryDetail>}
      </BenefitDetailsContainer>
    </VerticalSpacer>
  </Modal>
}

export default LoyaltyRoomUpgradeBenefitModal
